module.exports = __webpack_public_path__ + "static/media/boitesTupp_02_thumb_hover.3f9e01c1.png";